import axiosInstance from "./axiosInstance";
import {
  CreateQarzanTypePayload,
  QarzanTypeConfigFilters,
  UpdateQarzanTypePayload,
} from "types/qarzanHassana";

// Helper to get token safely
export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getQarzanTypeList = async (
  filters: QarzanTypeConfigFilters = {},
) => {
  try {
    const response = await axiosInstance.get("/qarzan-type/list", {
      params: {
        pageNo: filters.pageNo ?? 0,
        pageSize: filters.pageSize ?? 20,
        searchText: filters.searchTerm || undefined,
        qarzantypeName: filters.qarzantypeName || undefined,
        qarzanCode: filters.qarzanCode || undefined,
        status: filters.status || undefined,
      },
      headers: {
        ...getAuthHeader(),
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createQarzanType = async (payload: CreateQarzanTypePayload) => {
  try {
    const response = await axiosInstance.post("/qarzan-type", payload, {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateQarzanType = async (payload: UpdateQarzanTypePayload) => {
  try {
    const response = await axiosInstance.put("/qarzan-type", payload, {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteQarzanType = async (
  guid: string,
  deletedBy: string,
): Promise<void> => {
  await axiosInstance.delete(`/qarzan-type/${guid}`, {
    params: {
      deletedBy,
    },
    headers: {
      ...getAuthHeader(),
    },
  });
};
